import { EdgesCanvas } from "canvas/edge/canvas/canvas";
import { getDiagramEdges } from "canvas/edges-map";
import { DiagramElements } from "canvas/elements";
import { TableInactive } from "canvas/table/inactive/inactive";
import { EditDiagram } from "diagram/model/edit/edit";
import { Size } from "geometry/geometry";
import { useHost } from "host/host";
import { PreferencesContext } from "preferences/preferences";
import * as React from "react";
import { getCanvasStyle } from "../active/active";
import { useViewportSize } from "../active/use-viewport-size";

interface Props {
    diagram: EditDiagram;
    elements: DiagramElements;
    /** When provided, canvas min size equals this container (for full background). */
    container?: HTMLDivElement | null;
}

export const CanvasInactive = (props: Props) => {
    const host = useHost();
    const prefs = React.useContext(PreferencesContext).preferences;
    const edgesMap = getDiagramEdges(props.diagram.refs);

    const viewportSize = useViewportSize(props.container ?? null);
    const effectiveSize: Size =
        viewportSize !== null
            ? {
                  width: Math.max(props.diagram.size.width, viewportSize.width),
                  height: Math.max(
                      props.diagram.size.height,
                      viewportSize.height
                  ),
              }
            : props.diagram.size;

    return (
        <div
            className={"relative"}
            style={getCanvasStyle(prefs.zoom, effectiveSize, host)}
            ref={(element) => void (props.elements.canvas = element)}
        >
            {/* Separated backgrounds to ensure they are included in
            screenshot mode */}
            <div
                className={[
                    "absolute top-0 left-0 w-full h-full z-0",
                    "-outline-offset-1",
                    "shadow-[var(--slate1)]",
                    "bg-[var(--diagram-canvas-bg)]",
                    "outline-8",
                ].join(" ")}
            />
            <div
                className={[
                    "absolute top-0 left-0 w-full h-full z-0",
                    "diagram-canvas-grid",
                ].join(" ")}
            />
            <EdgesCanvas
                diagram={props.diagram}
                diagramDispatch={() => {}}
                elements={props.elements}
                isCanvasActive={false}
                effectiveSize={effectiveSize}
            />
            {props.diagram.tables.map((table) => (
                <TableInactive
                    key={table.id}
                    table={table}
                    tableEdges={edgesMap.get(table.id) ?? null}
                    elements={props.elements}
                    columns={props.diagram.columns}
                />
            ))}
        </div>
    );
};
